import { Build, ContactMail, Home, Info, Work, AutoAwesome } from "@mui/icons-material";

export const LocalWebLink = [
    {
         name: "Home",
         icon:  <Home/>,
         linkUrl: "/",
         link: true
    },
    {
         name: "Tools",
         icon: <AutoAwesome/>,
         linkUrl: "/tools/snapstudio",
         link: true,
         isDropdown: true,
         subLinks: [
              {
                   name: "SnapStudio",
                   desc: "App Store Mockup Studio",
                   badge: "FREE",
                   linkUrl: "/tools/snapstudio"
              }
         ]
    },
    {
         name: "Work",
         icon: <Work/>,
         linkUrl: "/#work",
         link: false
    },
    {
         name: "About",
         icon: <Info/>,
         linkUrl: "/#aboutMe",
         link: false
    },
    {
         name: "Service",
         icon: <Build/>,
         linkUrl: "/#service",
         link: false
    },
    {
         name: "Contact",
         icon: <ContactMail/>,
         linkUrl: "/#contactUs",
         link: false
    },
];

